import * as React from "react";

export const SliderControlIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
  width?: number;
  height?: number;
}> = ({ width, height, className, size = 24, color = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 36 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    color={color}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V32C36 36.4183 32.4183 40 28 40H8C3.58172 40 0 36.4183 0 32V8Z"
      fill="var(--surface-surface-accent, #38724e)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 8C27.5523 8 28 8.48842 28 9.09091V30.9091C28 31.5116 27.5523 32 27 32C26.4477 32 26 31.5116 26 30.9091V9.09091C26 8.48842 26.4477 8 27 8Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31 8C31.5523 8 32 8.48842 32 9.09091V30.9091C32 31.5116 31.5523 32 31 32C30.4477 32 30 31.5116 30 30.9091V9.09091C30 8.48842 30.4477 8 31 8Z"
      fill="white"
    />
  </svg>
);
